import { get, post } from "../GenericServices";

const FlatRateAmount = {
  getFlatRateAmount: () => {
    return get("flat-rate-amount/1");
  },
  saveFlatRateAmount: (data) => {
    return post("flat-rate-amount", data);
  },
};

export default FlatRateAmount;
